import { PayloadAction } from '@reduxjs/toolkit';
import { IBroker } from '../../broker/interfaces/IBroker';

export const BrokerReducer = {
	setBroker: (state: IBroker, action: PayloadAction<IBroker>) => {
		state.legal_name = action.payload.legal_name;
		state.city = action.payload.city;
		state.address = action.payload.address;
		state.address_number = action.payload.address_number;
		state.id = action.payload.id;
		state.name = action.payload.name;
		state.postal_code = action.payload.postal_code;
		state.tax_id = action.payload.tax_id;
		state.website = action.payload.website;
		state.phone = action.payload.phone;
		state.email = action.payload.email;
		state.owner_email = action.payload.owner_email;
		state.needs_bank_info = action.payload.needs_bank_info;
		state.logo = action.payload.logo;
	},
	setNeedsBankInfo: (state: IBroker, action: PayloadAction<boolean>) => {
		state.needs_bank_info = action.payload;
	},
	setLogo: (state: IBroker, action: PayloadAction<string>) => {
		state.logo = action.payload;
	},
	updateIpafInProgress: (state: IBroker, action: PayloadAction<boolean>) => {
		state.ipaf_in_progress = action.payload;
	},
};
